import { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { Block } from "../../../hoc/Block";
import styles from "./DropdownChecklist.module.css";

// let selectedItems = [];

const DropdownChecklist = (props) => {
  const [isListVisible, setIsListVisible] = useState(false);
  const [selectedValues, setSelectedValues] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);

  let guid = new Date().getTime();
  useEffect(() => {
    let mounted = true;

    if (mounted) {
      setSelectedValues("");
      
      // console.log("DATA ", props.data);
      if(props.data.length > 0) {
        if (props.name === "controlFunctions") {
          if (props.defaultValue) { // if the api fails, this check might be needed (although in the case of api fail and an error occurs it should be handled by ErrorBoundary)
            const selectedCF = props.data.filter((item) => item.value===props.defaultValue)[0];
            setSelectedValues(selectedCF ? selectedCF.name : "");
            // setSelectedValues(props.data.filter((item) => item.value===props.defaultValue)[0].name); // sometimes this creates an error when the post request finishes
          }
        } else {
          let items = [];
          for (const el of props.data) {
            if (el.checked) {
              items.push(el.name)
            }
          }
          setSelectedItems(items)
          setSelectedValues(items.join(", "));
        }
      }
    }

    return(() => {
      mounted = false;
    })
  },[props.data]);

  const changeVisibility = () => {
    if (isListVisible === false) setIsListVisible(true);
    else setIsListVisible(false);
  };

  const onChange = function(e) {
    if(props.inputType === "radio") {
      setSelectedValues(e.target.id);
    } else {
      let newItems = [...selectedItems];
      if(e.target.checked) {
        newItems.push(e.target.id);
      } else {
        newItems = newItems.filter((item) => item !== e.target.id);
      }
      setSelectedItems(newItems)
      setSelectedValues(newItems.join(", "));
    }
    props.onChange(e);
  }
  // console.log("opScopes: ", props.data);
  return (
    <Block>
        <div className={`${styles.backdrop} ${isListVisible ? "visible" : "invisible"}`} onClick={changeVisibility}></div>
        <Row>
          <label className="fst-italic">{props.children}</label>
        </Row>
        <Row>
          <div 
            id="list1"
            className={`${styles.dropdownCheckList} smallItalic`}
          >
            <span
              className={`${styles.anchor} ${selectedValues === "" ? styles.redStyle : ""} nexiColor overflow-hidden`}
              onClick={changeVisibility}
              >
              {selectedValues != "" ? selectedValues : props.emptyListMessage}
            </span>
            <ul className={`${styles.items} ${isListVisible ? "visible" : "invisible"} overflow-visible`}>
              {props.data.map((el, index) => {
                return (
                  <li key={el.value + index} onChange={onChange}>
                    <input
                      id={el.name}
                      name={props.name}
                      value={el.value}
                      disabled={el.active !== undefined && !el.active}
                      type={props.inputType}
                      defaultChecked={
                        (el.value === props.defaultValue &&
                        props.name === "controlFunctions") 
                        ||
                        (props.name === "operationalScopes" &&
                        el.checked)
                      }
                    />
                    <label htmlFor={el.name}>{el.name}</label>
                  </li>
                )})}
            </ul>

          </div>
        </Row>
      </Block>
  );
};

export default DropdownChecklist;
